// ==================== PATCH CARRINHO SABINO ====================

// Ignora erro de propriedade protect
try {
  if (typeof window.cart === 'object' && window.cart !== null) {
    Object.defineProperty(window.cart, 'protect', {
      writable: true,
      configurable: true,
      value: window.cart.protect || {}
    });
  }
} catch (e) {
  console.warn('Patch cart: erro protect ignorado', e);
}

// Bloqueia fetch/XHR quebrados
(function() {
  const brokenURLs = [
    'https://app.sabin0vision.com.br/api/theme/verify',
    'https://api.finalizarcompra.io/public/shopify/cart'
  ];

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function(input, init) {
      if (typeof input === 'string' && brokenURLs.includes(input)) {
        console.warn('Fetch bloqueado para URL quebrada:', input);
        return new Promise(resolve => resolve({ok: true, json: () => ({})}));
      }
      return originalFetch.apply(this, arguments);
    };
  }
})();

// Forçar abertura do drawer do cart
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(() => {
    const cartDrawer = document.querySelector('.cart-drawer, .drawer--cart');
    if (cartDrawer) {
      cartDrawer.style.display = 'block';
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});
});

console.log('Patch cart Sabino aplicado');
